import React from 'react';
import { Modal, Form, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

const RemovePersonFromGroupConfimModal = Form.create({
  name: 'remove_person_from_group_confim_modal'
})(
  // eslint-disable-next-line
  class extends React.Component {
    static defaultProps = {
      visible: false,
      maskClosable: true,
      destroyOnClose: true,
      width: 405,
      title: 'Remove person',
      okText: 'Remove',
      cancelButtonProps: {
        type: 'link',
        'data-people-people-id':
          'remove-person-from-group-confirm-modal-cancel-link'
      },
      okButtonProps: {
        loading: false,
        'data-people-people-id':
          'remove-person-from-group-confirm-modal-remove-button'
      },
      centered: true,
      onCancel() {},
      onOk() {}
    };

    render() {
      const {
        visible,
        onCancel,
        onCreate,
        maskClosable,
        destroyOnClose,
        width,
        title,
        okText,
        cancelButtonProps,
        centered,
        okButtonProps
      } = this.props;
      return (
        <Modal
          destroyOnClose={destroyOnClose}
          width={width}
          centered={centered}
          maskClosable={maskClosable}
          visible={visible}
          title={title}
          okText={okText}
          cancelButtonProps={cancelButtonProps}
          onCancel={onCancel}
          onOk={onCreate}
          okButtonProps={okButtonProps}
        >
          <Typography.Paragraph>
            <FormattedMessage id="DeleteGroupPersonConfirm" defaultMessage="Are you sure you want to remove person from this group?" />
          </Typography.Paragraph>
        </Modal>
      );
    }
  }
);
export default RemovePersonFromGroupConfimModal;
